import { Autocomplete as MuiAutocomplete, type AutocompleteProps as MuiAutocompleteProps } from "@mui/material";

export type AutocompleteProps<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> = MuiAutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>;

export const Autocomplete = MuiAutocomplete;
